import { print } from 'graphql';
import { getBnySatGraphBaseUrl } from '../../../services/apiService';
import { createApiThunk, graphqlCall } from '../../../utils/api';
import {
  getBasketsbyDateRangeQuery,
  getOrderDetailsByIdQuery,
  getSecurityDetailsQuery,
} from './OrderDetailsQueries';
import { getInventoryDataQuery } from '../../../pages/SwapBaskets/SwapBasketsQueries';

export const getOrderDetailsByIdThunk = createApiThunk('GET_ORDER_DETAILS_BY_ID', graphqlCall);
export const getSecurityDetailsThunk = createApiThunk('GET_SECURITY_DETAILS', graphqlCall);
export const getBasketsbyDateRangeThunk = createApiThunk('GET_BASKETS_BY_DATE_RANGE', graphqlCall);
export const getInventoryDataForSubstitutionThunk = createApiThunk(
  'GET_INVENTORY_DATA_SUBSTITUTION',
  graphqlCall,
);

export const getOrderDetailsById =
  (orderId: string, version: number) => (dispatch: AppDispatch) => {
    const url = getBnySatGraphBaseUrl();
    const query = print(getOrderDetailsByIdQuery(orderId, version));
    return dispatch(getOrderDetailsByIdThunk({ url, query }));
  };

export const getSecurityDetails = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getSecurityDetailsQuery());
  return dispatch(getSecurityDetailsThunk({ url, query }));
};

export const getBasketsbyDateRange =
  (orderId: string, swapCurrency: string, fromDate: string | null, toDate: string | null) =>
  (dispatch: AppDispatch) => {
    const url = getBnySatGraphBaseUrl();
    const query = print(getBasketsbyDateRangeQuery(orderId, swapCurrency, fromDate, toDate));
    return dispatch(getBasketsbyDateRangeThunk({ url, query }));
  };

export const getInventoryDataForSubstitution = (data: any) => (dispatch: AppDispatch) => {
  const url = getInventoryDataQuery();
  const method = 'POST';
  return dispatch(getInventoryDataForSubstitutionThunk({ url, data, method }));
};
